"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/SwatchColorPicker/index"), exports);
//# sourceMappingURL=SwatchColorPicker.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/SwatchColorPicker.js
// module id = ../node_modules/office-ui-fabric-react/lib/SwatchColorPicker.js
// module chunks = 1